import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
  Paper,
  Checkbox,
  IconButton,
  Snackbar,
  CircularProgress,
  Fade,
  FormControlLabel,
  Switch,
  Popover,
  Tooltip,
  Skeleton,
  tooltipClasses,
  useMediaQuery,
  Stack,
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { Link, useLocation } from 'react-router-dom';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { ArrowCircleRight, Clear, Close, Delete, Edit, EditOff } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { MoreVert } from '@mui/icons-material';
import { alpha, styled } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import ConfirmDeleteModal from '../../components/modals/ConfirmDeleteModal';
import { MoneyFormat, MoneyFormatv3 } from '../../library/MoneyFormat';
import { CloudDownload, CloudUpload } from '@mui/icons-material';
import { API, graphqlOperation } from 'aws-amplify';
import DeleteJournalEntry from '../../components/modals/DeleteJournalEntry';
import DeleteSelectedEntry from '../../components/modals/DeleteSelectedEntry';
import { ThreeDot } from '../../components/DropDown/ThreeDot';
import DropDownForListing from '../../components/DropDown/DropDown';
import { ListSelection_fn } from '../../library/ListSelection';
import { cancelTransactionMaster } from '../../graphql/mutations';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import { useWarningModal } from '../../components/modals/AddUnits';
import ExportData from '../../components/modals/ExportData';
import LinkList from '../../components/Buttons/linkList';
import { updateTitle, updateViewTitle } from '../../redux/reducers/titleSlice';
import { listTransactionMasterCount, listTransactionMasterv2 } from '../../graphql';
import { useDebounce } from '../../hooks/useDebounce';
import { DateRangeRsuite, MoneyTextFieldRange, SimplePeriodDropdown } from '../../components';
import PeriodDropDown from '../../components/DropDown/PeriodDropDown';
import { defaultRowsPerPage, defaultRowsPerPageOptions, getDefaultSorting, handleFreeze } from '../../utils/common';
import MoneyRanger from '../../components/formElements/MoneyRanger';
import { useThemes } from '../../components/Theme/theme';
import { listTransactionMasterv2Custom } from '../../graphql';
import TableSearchButton from '../PrimeFigma/Components/TableSearchButton';
import { TableCell } from '../../components/Table/TableCell';
import RollingSoon from '../../components/Ui/RollingSoon';
import { formatUnixTimestamp } from '../../library';

const data = [
  {
    id: 1,
    journalDate: '2022-12-10',
    journalVoucherNo: '120475671',
    amount: 15700,
    remarks: '',
    entries: [
      {
        account: 'GST Payable',
        amount: 50000,
        description: '',
        debit: 0,
        credit: 0,
      },
      {
        account: 'IGST input',
        amount: 50000,
        description: '',
        debit: 1000,
        credit: 0,
      },
    ],
  },
  {
    id: 2,
    journalDate: '2022-12-11',
    journalVoucherNo: '120475672',
    amount: 15700,
    remarks: '',
    entries: [{ account: '', amount: 0, description: '', debit: 0, credit: 0 }],
  },
  {
    id: 3,
    journalDate: '2022-12-12',
    journalVoucherNo: '120475673',
    amount: 15700,
    remarks: '',
    entries: [{ account: '', amount: 0, description: '', debit: 0, credit: 0 }],
  },
  {
    id: 4,
    journalDate: '2022-12-13',
    journalVoucherNo: '120475674',
    amount: 15700,
    remarks: '',
    entries: [{ account: '', amount: 0, description: '', debit: 0, credit: 0 }],
  },
  {
    id: 5,
    journalDate: '2022-12-14',
    journalVoucherNo: '120475675',
    amount: 15700,
    remarks: '',
    entries: [{ account: '', amount: 0, description: '', debit: 0, credit: 0 }],
  },
  {
    id: 6,
    journalDate: '2022-12-15',
    journalVoucherNo: '120475676',
    amount: 15700,
    remarks: '',
    entries: [{ account: '', amount: 0, description: '', debit: 0, credit: 0 }],
  },
  {
    id: 7,
    journalDate: '2022-12-16',
    journalVoucherNo: '120475677',
    amount: 15700,
    remarks: '',
    entries: [{ account: '', amount: 0, description: '', debit: 0, credit: 0 }],
  },
  {
    id: 8,
    journalDate: '2022-12-17',
    journalVoucherNo: '120475678',
    amount: 15700,
    remarks: '',
    entries: [{ account: '', amount: 0, description: '', debit: 0, credit: 0 }],
  },
  {
    id: 9,
    journalDate: '2022-12-18',
    journalVoucherNo: '120475679',
    amount: 15700,
    remarks: '',
    entries: [{ account: '', amount: 0, description: '', debit: 0, credit: 0 }],
  },
  {
    id: 10,
    journalDate: '2022-12-19',
    journalVoucherNo: '120475680',
    amount: 15700,
    remarks: '',
    entries: [{ account: '', amount: 0, description: '', debit: 0, credit: 0 }],
  },
];

const PinkSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#fff',
    '&:hover': {
      backgroundColor: alpha('#fff', theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#fff',
  },
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCell = [
  {
    id: 'VoucherNumber',
    numeric: false,
    disablePadding: false,
    label: 'Voucher No',
    width: '150px',
  },
  {
    id: 'EntryDate',
    numeric: false,
    disablePadding: true,
    label: 'Journal Date',
    width: '150px',
  },

  // {
  //   id: 'accountName',
  //   numeric: false,
  //   disablePadding: false,
  //   label: 'Account Name',
  //   width: '130px'
  // },
  {
    id: 'amount',
    numeric: true,
    disablePadding: false,
    label: 'Amount (₹)',
    width: '130px',
  },
  // {
  //   id: 'debit',
  //   numeric: false,
  //   disablePadding: false,
  //   label: 'Debit',
  //   width: '130px'
  // },
  // {
  //   id: 'credit',
  //   numeric: false,
  //   disablePadding: false,
  //   label: 'Credit',
  //   width: '130px'
  // },
  // {
  //   id: 'description',
  //   numeric: false,
  //   disablePadding: false,
  //   label: 'Description',
  //   width: '130px'
  // },
  {
    id: 'Comments',
    numeric: false,
    disablePadding: false,
    label: 'Narration',
    width: '130px',
  },
  {
    id: 'Action',
    numeric: false,
    disablePadding: false,
    label: 'Actions',
    width: '80px',
  },
];

const expandHeadCell = [
  {
    id: 'VoucherNumber',
    numeric: false,
    disablePadding: false,
    label: 'Voucher No',
    width: '150px',
  },
  {
    id: 'EntryDate',
    numeric: false,
    disablePadding: true,
    label: 'Journal Date',
    width: '150px',
  },
  {
    id: 'AccountID',
    numeric: false,
    disablePadding: false,
    label: 'Account Name',
    width: '130px',
  },
  {
    id: 'debit',
    numeric: true,
    disablePadding: false,
    label: 'Debit (₹)',
    width: '130px',
  },
  {
    id: 'credit',
    numeric: true,
    disablePadding: false,
    label: 'Credit (₹)',
    width: '130px',
  },
  // {
  //   id: "description",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Description",
  //   width: "130px",
  // },
  {
    id: 'Comments',
    numeric: false,
    disablePadding: false,
    label: 'Description',
    width: '130px',
  },
  {
    id: 'Action',
    numeric: false,
    disablePadding: false,
    label: 'Actions',
    width: '80px',
  },
];

const accountsArr = {
  4: 'Purchase',
  5: 'Cash',
  12: 'Sales',
  18: 'Bank Loan Payable',
};

const colors = {
  0: '#96abec4f',
  1: '#def6d4',
  2: '#F0FFFF',
  3: '#F8F6F0',
  4: '#f3dcf8',
  5: '#e6eff2',
  6: '#ddf8db',
  7: '#ADD8E6',
  8: '#96DED1',
  9: '#dcf7fa',
};

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, mapArr, onDelete, setEnableSearch,setShowActions,showActions, scroll} = props;
  const { theme } = useThemes();

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow
        sx={{
          '.MuiTableCell-root': {
            backgroundColor: `${theme.palette.background.tablebg} !important`,
            fontSize: '14px',
          },
          '.MuiTableCell-head': {
            backgroundColor: 'background.tablebg',
            padding: '2px 10px',
            borderBottom: '0px',
          },
          height: '35px',
        }}
      >
        {/* <TableCell
          padding="checkbox"
          sx={{
            ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root": {
              padding: "5px",
            },
          }}
        >
          <Checkbox
            sx={{ color: "input.border" }}
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all desserts",
            }}
            size="small"
          />
        </TableCell> */}
        {mapArr.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              minWidth: headCell.width,
              position: headCell.id === 'Action' ? 'sticky' : '',
              right: headCell.id === 'Action' ? 0 : '',
              // borderLeft: headCell.id === "Action" ? "1px solid" : "0px",
            }}
            //  sx={{minWidth:headCell.width}}
          >
            <Box
              sx={{
               display: 'flex',
              justifyContent:headCell.id === "Action" ? "center" : 'space-between',
              alignItems: 'center',
              flexDirection: headCell.numeric ? 'row-reverse' : '',
              // border: headCell.id === "Action" ? "1px solid black" : "",
              borderRadius:headCell.id === "Action" ? "3px" : "",
              width:"100%",
              backgroundColor:headCell.id === "Action" ? "white" : 'background.tablebg',
              boxShadow: (headCell.id === "Action") && (scroll) ?  "0px 4px 8px rgba(0, 0, 0, 0.6)" : "",
              "&:active": 
                {
                  transform: scroll ? "scale(0.92)":"scale(1)",
                },
              }}
              onClick={(e) => {
                if(headCell.label === 'Actions'){
                    setShowActions((pre) => !pre)  
                  }
              }}
            >
              {headCell.id != 'Action' ? (
                <>
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    onClick={createSortHandler(headCell.id)}
                  >
                    <Box sx={{ display: 'flex' }}>
                      <Box sx={{ whiteSpace: 'nowrap' }}>{headCell.label}</Box>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {orderBy === headCell.id ? (
                          <Box
                            //  component="span"
                            sx={visuallyHidden}
                          >
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </Box>
                        ) : null}
                        {/* {headCell.id !== "Action" ? (
                          <SearchIcon
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setEnableSearch((prev) => !prev);
                            }}
                            sx={{ marginLeft: "10px" }}
                            fontSize="small"
                          />
                        ) : null} */}
                      </Box>
                    </Box>
                  </TableSortLabel>
                  {/* <IconButton sx={{ margin: '0px 2px', padding: '5px', }}>
                    <FilterAltIcon fontSize='small' sx={{ color: 'primary.main' }} />
                  </IconButton> */}
                </>
              ) : (
                <Box 
                  sx={{
                    display:"flex",
                    alignItems:"center",
                    backgroundColor:headCell.id === "Action" ? "white" : 'background.tablebg',
                    }}
                  >
                    {headCell.label}
                    {(headCell.id === "Action") && (scroll) ?
                     <ArrowCircleRight
                        sx={{
                          transition: 'transform 0.3s ease-in-out',
                          marginLeft: '10px',
                          transform : scroll ? (!showActions ?  'rotate(0deg)' : 'rotate(180deg)') : "rotate(180deg)",
                          color:scroll ? (!showActions ? 'gray' : '#ee5b2b') : ('#ee5b2b'),
                        }}
                        fontSize="small"
                    />  :
                    null
                  }
                      
                </Box>
              )}
            </Box>
          </TableCell>
        ))}
        {numSelected > 0 ? (
          <TableCell>
            <ThreeDot
              onDelete={() => {
                onDelete(true);
              }}
            />
          </TableCell>
        ) : null}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function AllJournalEntries() {
  const { theme } = useThemes();

  const dispatch = useDispatch();
  dispatch(display());

  const navigate = useNavigate();
  let location = useLocation();

  const { defaultSortingColumn, defaultSortingOrder } = getDefaultSorting('voucher');
  const [order, setOrder] = useState(defaultSortingOrder);
  const [orderBy, setOrderBy] = useState(defaultSortingColumn);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [firstMount, setfirstMount] = useState({ current: true });
  const [dataCount, setdataCount] = useState([]);
  const [showActions,setShowActions] = useState(true)

  useEffect(() => {
    if (firstMount.current) {
      setfirstMount({ current: false });
    }
  }, []);

  useEffect(() => {
    const controlAndS = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === 's') {
        e.preventDefault();
        // showErrorSnackbar("Nothing to save");
      }
    };

    window.addEventListener('keydown', controlAndS);

    return () => {
      window.removeEventListener('keydown', controlAndS);
    };
  }, []);
  const [deleteSnackBar, setDeleteSnackBar] = useState(false);
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [rows, setRows] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [circularOpen, setCircularOpen] = useState(true);
  const [deleteSelectedModal, setDeleteSelectedModal] = useState(false);
  const [expandState, setExpandState] = useState({});
  const [expandTable, setExpandTable] = useState(false);
  const [itemData, setItemData] = useState({});
  const [deleteItemModal, setDeleteItemModal] = useState(false);
  // const [filteredList, setFilteredList] = useState([]);
  const [totalAMount, setTotalAMount] = useState([]);
  const [accountsObj, setAccountsObj] = useState({});
  const [accName, setAccName] = useState([]);
  const [ListSelection, setListSelection] = useState('All');
  const defaultFilterColumns = {
    VoucherNumber: '',
    date: '',
    amount: '',
    Comments: '',
    // accountName: "",
    PaidFrom: '',
    debit: '',
    credit: '',
    description: '',
    ReceiptDateTo: '',
    ReceiptDateFrom: '',
    AmountFrom: '',
    AmountTo: '',
    CreditFrom: '',
    CreditTo: '',
    DebitFrom: '',
    DebitTo: '',
  };
  const [filterColumns, setFilterColumns] = useState(defaultFilterColumns);
  const handleResetFilterColumns = (status) => (status === false ? setFilterColumns(defaultFilterColumns) : null);

  // useEffect(() => {
  //   if (localStorage.getItem('journalentries')) {
  //     setRows(JSON.parse(localStorage.getItem('journalentries')))
  //   } else {
  //     localStorage.setItem('journalentries', JSON.stringify(data));
  //     setRows(data)
  //   }
  // }, [deleteModalStatus])

  const [exportItem, setExportItem] = useState(null);
  const [exportModalOpen, setExportModalOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  // Click handler for the main box to open the popover
  const handleClickBox = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  // Click handler to close the popover
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Check if the popover should be open based on anchorEl
  const Popen = Boolean(anchorEl);

  // Options to display in the popover, each with a label and onClick handler
  const options = [
    // {
    //   label: 'Import',
    //   icon: <CloudDownload sx={{color: "blue"}}/>,
    //   onClick: () => {},
    //   link: '/import-data',
    // },
    {
      label: 'Export',
      icon: <CloudUpload sx={{color: "#ffa500"}}/>,
      onClick: () => {
        if (rows.length > 0) {
          setExportModalOpen(true);
          setExportItem('Journal Entries');
        } else {
          // setWarningSnakbar(true);
          // setWarningMsg("No data available for export.");
          showWarningSnackbar('No data available for export.');
        }
      },
      link: '',
      rollingOutSoon: true
    },
  ];

  useEffect(() => {
    if (rows.length > 0) {
      let obj = {};
      let arr = [];
      rows?.map((ele, ind) => {
        let totalCredit = 0;
        ele?.RelatedTransactionDetails?.map((item, index) => {
          totalCredit += Number(item?.CreditAmount);
        });
        arr.push(totalCredit);
        obj[ind] = false;
      });
      setExpandState(obj);
      setTotalAMount(arr);
      //console.log(expandState);
    }
  }, [rows]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked && rows.length) {
      const newSelected = rows.map((n) => n.TransactionID);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    if (circularOpen) return;
    console.log(event, newPage);
    if (newPage > page) {
      console.log(newPage);
      if (rows.length !== dataCount)
        if (rows.length < rowsPerPage * (newPage + 1)) {
          getJournalEntries(false, rows.length, Math.abs(rowsPerPage * (newPage + 1) - rows.length));
        }
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const [limit, setlimit] = useState(rowsPerPage);

  // const [dataLoader,setDataLoader] = useState(true)

  async function getJournalEntries(reset, from, to, filterColumn) {
    setCircularOpen(true);
    try {
      // const resDeleted = API.graphql(graphqlOperation(listDeletedPayments, { Type: "Payment" }))
      if (rows.length / rowsPerPage == page + 1) {
        setlimit(to);
      } else if (rows.length / rowsPerPage < 1) {
        setlimit(rowsPerPage - rows.length);
      }
      setCircularOpen(true);
      if (reset) {
        setRows([]);
        setPage(0);
      }
      let searchMode = 1;
      let SearchArray = [{ journal: '' }];
      filterColumn = filterColumn ? filterColumn : filterColumns;
      console.log(filterColumn, filterColumns);
      // Handle AmountFrom and AmountTo together to avoid duplicates
      const amountFrom = filterColumn.AmountFrom ||'';
      const amountTo = filterColumn.AmountTo || ''
      
      if (amountFrom || amountTo) {
        searchMode = 1;
        // Ensure From < To before adding to SearchArray
        const lowerAmount = Number(amountFrom < amountTo ? amountFrom : amountTo);
        const higherAmount = Number(amountFrom < amountTo ? amountTo : amountFrom);
        
        // Add both values with correct order
        SearchArray = [...SearchArray, { amountfrom: lowerAmount }, { amountto: higherAmount }];
      } else if (amountFrom) {
        searchMode = 1;
        SearchArray = [...SearchArray, { amountfrom: amountFrom }];
      } else if (amountTo) {
        searchMode = 1;
        SearchArray = [...SearchArray, { amountto: amountTo }];
      }

      Object.keys(filterColumn).map((key) => {
        // Skip amount range fields as they are handled above
        if (key === 'AmountFrom' || key === 'AmountTo') {
          return;
        }
        
        if (filterColumn[key]?.toString()?.length > 0) {
          searchMode = 1;
          SearchArray = [...SearchArray, { [key?.toLowerCase()]: filterColumn[key] }];
        }
      });
      switch (ListSelection) {
        case 'Active':
          SearchArray = [...SearchArray, { CancelFlag: 0 }];
          break;
        case 'Cancelled':
          SearchArray = [...SearchArray, { CancelFlag: 1 }];
          break;
        default:
          break;
      }

      const transcationMaster = await API.graphql(
        graphqlOperation(listTransactionMasterv2, {
          transactiontypecd: 'ManualJournal',
          rowfrom: from,
          limitno: to,
          columnname: orderBy,
          ordertype: order.toUpperCase(),
          searchmode: searchMode,
          searcharray: JSON.stringify(SearchArray),
        })
      );
      console.log({transcationMaster})
      const transcationCount = await API.graphql(
        graphqlOperation(listTransactionMasterCount, {
          transactiontypecd: 'ManualJournal',
          rowfrom: from,
          limitno: to,
          columnname: orderBy,
          ordertype: order.toUpperCase(),
          searchmode: searchMode,
          searcharray: JSON.stringify(SearchArray),
        })
      );

      setdataCount(
        transcationCount.data.listTransactionMasterCount?.[0].statuscode == ''
          ? transcationCount.data.listTransactionMasterCount?.[0].transactionmasterlistcount
          : 0
      );

      let arr = [];
      let arrD = [];
      arr = transcationMaster.data.listTransactionMasterv2.filter((elem) => elem.statuscode == null || elem.statuscode == '');
      let cArr = [...arr, ...arrD];
      if (reset) {
        setRows((prev) => [...cArr]);
        setCircularOpen(false);
      } else {
        setRows((prev) => [...prev, ...cArr]);
        setCircularOpen(false);
      }
      setlimit(0);
      setCircularOpen(false);
    } catch (error) {
      setlimit(0);
      console.log('error', error);
      setCircularOpen(false);
    }
  }

  useEffect(() => {
    console.log(order, orderBy);
    setRows([]);
    setPage(0);
    getJournalEntries(true, 0, rowsPerPage);
    return () => {};
  }, [order, orderBy]);
  useEffect(() => {
    console.log(rowsPerPage, rows.length);
    if (firstMount.current === false) {
      if (rowsPerPage > rows.length) {
        console.log(rowsPerPage, rows.length);
        getJournalEntries(true, 0, rowsPerPage);
      } else {
        console.log(rowsPerPage, rows.length);
      }
    }
    return () => {};
  }, [rowsPerPage]);

  const jurTableRef = useRef(null)
     const [scroll,setScroll] = useState(false)
       useEffect(() => {
       if (rows.length > 0 && !circularOpen) {
         const width = jurTableRef.current?.offsetWidth;
         const screenWidth = window.innerWidth;
         if (width < screenWidth) {
          setScroll(false)
         } else {
           setScroll(true);
         }
       }
     }, [rows, circularOpen]);

  let { WarningModal, handleOpen: setWarningOpen } = useWarningModal();

  const [state, setState] = useState({
    reason: '',
    errorFields: {
      reason: '',
    },
    errorStatus: {
      reason: false,
    },
  });
  const cancel = async (id, type, voucherNo) => {
    return new Promise(async (resolve, reject) => {
      try {
        let data = {
          TransactionID: id,
          CancelFlag: 1,
          CancelRemark: state.reason,
          TransactionTypeCD: type,
          VoucherNumber: voucherNo,
        };
        console.log(data);
        let response = await API.graphql(
          graphqlOperation(cancelTransactionMaster, {
            updateTransactionMasterInput: data,
          })
        );
        let tempRows = JSON.parse(JSON.stringify(rows));
        let temp = tempRows.map((elem) => {
          if (elem.VoucherNumber == voucherNo) {
            elem.CancelFlag = 1;
            return elem;
          } else {
            return elem;
          }
        });
        setRows(temp);
        showSuccessSnackbar('Journal Entry Cancelled');
        // getJournalEntries();

        // console.log(response);
      } catch (error) {
        showErrorSnackbar('Something Went Wrong !');
        console.log(error);
      } finally {
        resolve();
      }
    });
  };
  const filterBySearch = (event, name, value) => {
    setPage(0);
    const query = value || event.target.value;
    const obj = { ...filterColumns };
    if (name == 'Amount') {
      obj['AmountFrom'] = query[0];
      obj['AmountTo'] = query[1];
    } else if (name == 'Credit') {
      obj['CreditFrom'] = query[0];
      obj['CreditTo'] = query[1];
    } else if (name == 'Debit') {
      obj['DebitFrom'] = query[0];
      obj['DebitTo'] = query[1];
    } else {
      for (const key in obj) {
        if (key == name) {
          obj[key] = query;
        } else {
          // obj[key] = "";
        }
      }
    }
    setFilterColumns(obj);
  };
  let search = (obj) => {
    console.log(obj);
    getJournalEntries(true, 0, rowsPerPage, obj);
  };
  const filterSearch = useCallback(
    useDebounce(
      (obj) => {
        search(obj);
      },
      500,
      false
    ),
    [ListSelection]
  );
  useEffect(() => {
    let searchFlag = false;
    console.log(filterColumns);
    if (firstMount.current === false) {
      if (
        Object.keys(filterColumns).map((key) => {
          if (filterColumns[key]?.toString()?.length > 0) {
            searchFlag = true;
          }
        })
      )
        console.log(searchFlag);
      // if (searchFlag) {
      filterSearch(filterColumns);
      // } else {
      //   listPurchaseandExpense(true, 0, rowsPerPage);
      // }
    }
    return () => {};
  }, [filterColumns, filterSearch, ListSelection]);
  const [EnableSearch, setEnableSearch] = useState(false);
  const DateRangeRefExpanded = useRef(null);
  const DateRangeRefRegular = useRef(null);
  const tableRefExpanded = useRef(null);
  const tableRefRegular = useRef(null);
  const openDateRange = () => {
    setEnableSearch(true);
    DateRangeRefExpanded?.current?.openDatePicker();
    DateRangeRefRegular?.current?.openDatePicker();
  };

  const device = useMediaQuery(theme.breakpoints.down('sm'));

  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
    const [rolling,setRolling] = useState(false)

  return (
    <Box className="noTableCellBorder">
      <Snackbar className="snackBar-delete" open={deleteSnackBar} autoHideDuration={6000} onClose={() => console.log('handleclose')}>
        <Box
          sx={{
            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
            display: 'flex',
            flexDirection: 'row',
            padding: '7px 20px',
            borderRadius: '7px',
            backgroundColor: '#fff',
            transition: 'all 2s ease-in-out',
            '&:hover': {
              boxShadow: 'rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px',
            },
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ color: 'rgb(60 60 60)', fontWeight: 'bold' }}>Delete selected rows ? </Typography>
            <Box onClick={() => setDeleteSnackBar(false)} sx={{ display: 'flex', flexDirection: 'row' }}>
              <Box
                sx={{
                  flex: 1,
                  backgroundColor: '#b1d1f97d',
                  margin: '2px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  '&:hover': {
                    cursor: 'pointer',
                  },
                  borderRadius: '7px',
                }}
              >
                <Typography sx={{ color: '#6096d9' }}>No</Typography>
              </Box>
              <Box
                onClick={() => setDeleteSelectedModal(true)}
                sx={{
                  flex: 1,
                  backgroundColor: '#fbc7c78c',
                  margin: '2px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  '&:hover': {
                    cursor: 'pointer',
                  },
                  borderRadius: '7px',
                }}
              >
                <Typography sx={{ color: '#d32f2f' }}>Yes</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Snackbar>

      <ConfirmDeleteModal open={deleteModalStatus} storage="journalentries" itemId={deleteId} setOpen={setDeleteModalStatus} />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderTopRightRadius: '12px',
          borderTopLeftRadius: '12px',
          padding: '8px 10px',
          backgroundColor: 'primary.main',
        }}
      >
        <LinkList list="All journal Entries" link="/addjournalentry" add="Add Entries" name="journal" />

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <TableSearchButton
            setEnableSearch={setEnableSearch}
            EnableSearch={EnableSearch}
            id={'journalSearch'}
            onClick={handleResetFilterColumns}
          />
          <Box
            sx={{
              display: {
                xs: 'none',
                sm: 'flex',
                md: 'flex',
                lg: 'flex',
                xl: 'flex',
                gap: '10px',
              },
            }}
          >
            <Box sx={{ marginRight: '10px' }}>
              <FormControlLabel
                value="Left"
                control={
                  <PinkSwitch
                    onChange={(e) => {
                      // if (e.target.checked) {
                      //   let obj = {}
                      //   rows.map((ele, ind) => {
                      //     obj[ind] = true
                      //   })

                      //   setExpandState(obj)
                      // } else {
                      //   let obj = {}
                      //   rows.map((ele, ind) => {
                      //     obj[ind] = false
                      //   })

                      //   setExpandState(obj)
                      // }
                      setExpandTable(!expandTable);
                      // setFilteredList(rows);
                      // setFilterColumns({
                      //   VoucherNumber: "",
                      //   date: "",
                      //   amount: "",
                      //   Comments: "",
                      //   accountName: "",
                      //   debit: "",
                      //   credit: "",
                      //   description: "",
                      // });
                    }}
                    color="success"
                  />
                }
                label="Expanded View"
                labelPlacement="start"
                sx={{
                  '.css-ahj2mt-MuiTypography-root': {
                    fontSize: '14px',
                  },
                  '& .MuiFormControlLabel-label': {
                    color: '#fff',
                  },
                  color: '#fff',
                }}
              />
            </Box>
            <Typography sx={{ fontSize: '13px', color: 'white', marginTop: '10px' }}>Total : {dataCount} Items</Typography>
            <DropDownForListing
              name={'ser'}
              value={ListSelection}
              onChange={(e) => {
                setListSelection(e.target.value);
                setPage(0);
              }}
            />
           <div className='dropdown-list'>
            <SimplePeriodDropdown
              value={{
                from: filterColumns.ReceiptDateFrom || null,
                to: filterColumns.ReceiptDateTo || null,
              }}
              onChange={(range) => {
                setFilterColumns((prev) => ({
                  ...prev,
                  ReceiptDateFrom: range.from || '',
                  ReceiptDateTo: range.to || '',
                }));
              }}
              title=""
              selectedWhenNull="year"
            />
            </div>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                borderRadius: '5px',
                p: 1,
                cursor: 'pointer',
                '&:hover': {
                  borderColor: '#ccc',
                  backgroundColor: theme.palette.input.border || '#f5f5f5',
                },
              }}
              onClick={handleClickBox} // Toggle the popover on box click
            >
              <MoreVert sx={{ fontSize: '20px', color: '#fff' }} />

              <Popover
                open={Popen}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <Box sx={{ p: 1,minWidth:"200px" }}>
                  {
                    options.map((option,index) => 
                      option.rollingOutSoon ? 
                      (
                        <Typography
                          key={index}
                          onClick={() => {
                            handleClose();
                          }}
                          sx={{
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            // '&:hover': {
                            //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                            // },
                          }}
                        >
                      <Tooltip 
                        title={<RollingSoon />}
                        placement="right"
                        PopperProps={{
                          sx: {
                            '& .MuiTooltip-tooltip': {
                              backgroundColor: 'transparent',
                              boxShadow: 'none',
                              padding: 0,
                            } 
                          }
                        }}
                      >      
                        <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            {option.icon}
                            <span style={{ marginLeft: '8px', opacity: 0.5 }}>
                              {option.label}
                            </span>
                        </Box>
                      </Tooltip> 
                        </Typography>
                      ): 
                      (<Link style={{ textDecoration: 'none', color: 'inherit' }} to={option.link} state={{ fromLink: '/customerList' }}>
                          <Typography
                            key={index}
                            onClick={() => {
                              handleClose();
                              option.onClick();
                            }}
                            sx={{
                              cursor: 'pointer',
                              padding: '8px',
                              display: 'flex',
                              alignItems: 'center',
                              // '&:hover': {
                              //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                              // },
                            }}
                          >
                            {option.icon}
                            <span style={{ marginLeft: '8px' }}>{option.label}</span>
                          </Typography>
                      </Link>)
                    )
                  }
                </Box>
              </Popover>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          // boxShadow: "inset 0 0 8px #d7d7d73b",
          boxShadow: 'rgb(33 35 38 / 10%) 0px 10px 10px -10px',
          borderBottomRightRadius: '12px',
          borderBottomLeftRadius: '12px',
          // backgroundColor: theme.palette.bodyGray.secondary,
          // borderRadius:'12px',
          padding: {
            // xs: "8px 12px",
          },
          '.css-1mxz8qt-MuiPaper-root': {
            boxShadow: 'none',
          },
          '.MuiTableCell-root': {
            padding: '1px 10px',
            fontSize: '13px',
          },
          '.MuiTableCell-head': {
            backgroundColor: 'background.tablebg',
            padding: '5px 10px',
            borderBottom: '0px',
          },
        }}
      >
        {!rows.length && device ? (
          <Typography
            sx={{
              height: '70vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            No data found
          </Typography>
        ) : (
          <>
            {expandTable ? (
              <Box sx={{ width: '100%', overflow: 'hidden', boxShadow: 'none' }}>
                <TableContainer
                  ref={tableRefExpanded}
                  className="custom-scrollbar"
                  sx={{
                    height: {
                      sm: 'calc( 100vh - 230px )',
                      xs: 'calc( 100vh - 180px )',
                    },
                  }}
                >
                  <Table
                    stickyHeader
                    aria-label="sticky table"
                    // sx={{ minWidth: 750 }}
                    aria-labelledby="tableTitle"
                    size={dense ? 'small' : 'medium'}
                  >
                    <EnhancedTableHead
                      EnableSearch={EnableSearch}
                      setEnableSearch={setEnableSearch}
                      numSelected={selected.length}
                      order={order}
                      orderBy={orderBy}
                      onSelectAllClick={handleSelectAllClick}
                      onRequestSort={handleRequestSort}
                      rowCount={dataCount}
                      mapArr={expandHeadCell}
                      onDelete={() => setDeleteSelectedModal(true)}
                      setShowActions = {setShowActions}
                      showActions = {showActions}
                      scroll = {scroll}
                    />
                    <TableBody ref = {jurTableRef}>
                      <TableRow
                        sx={{
                          '.MuiTableCell-root': {
                            backgroundColor: 'transparent !important',
                            padding: '8px 15px',
                          },
                          '.css-wrnu0i-MuiInputBase-root': {
                            fontSize: '13px',
                          },
                          '.css-xk0adg-MuiButtonBase-root-MuiIconButton-root': {
                            padding: '2px 4px',
                          },
                          '.css-1gqfvv-MuiPaper-root': {
                            boxShadow: 'none',
                            borderBottom: 'solid 1px rgba(0,0,0,0.24)',
                            borderRadius: '0px',
                          },
                          // visibility: !EnableSearch ? "collapse" : "visible",
                          display: !EnableSearch ? ' none' : 'content',
                        }}
                      >
                        {/* <TableCell></TableCell> */}
                        <TableCell>
                          <Paper
                            id="journalSearch"
                            sx={{
                              p: '2px 4px',
                              display: 'flex',
                              alignItems: 'center',
                              width: '100%',
                            }}
                          >
                            <InputBase
                              name="VoucherNumber"
                              value={filterColumns.VoucherNumber}
                              onChange={(e) => filterBySearch(e, 'VoucherNumber')}
                              sx={{ flex: 1 }}
                              placeholder="Search"
                              autoComplete="off"
                            />
                            <IconButton type="button" sx={{ p: '0px' }}>
                              {filterColumns.VoucherNumber !== '' ? (
                                <Clear
                                  fontSize="small"
                                  onClick={() => {
                                    setFilterColumns((prev) => ({
                                      ...prev,
                                      VoucherNumber: '',
                                    }));
                                    // setFilteredList(rows);
                                  }}
                                />
                              ) : (
                                <SearchIcon fontSize="small" />
                              )}
                            </IconButton>
                          </Paper>
                        </TableCell>
                        <TableCell>
                          <Paper
                            sx={{
                              p: '2px 4px',
                              display: 'flex',
                              alignItems: 'center',
                              width: '100%',
                            }}
                          >
                            {/* <InputBase
                            name="date"
                            value={filterColumns.date}
                            onChange={(e) => filterBySearch(e, "EntryDate")}
                            sx={{ flex: 1 }}
                            placeholder="Search"
                            autoComplete="off"
                          /> */}
                            <DateRangeRsuite
                              ref={DateRangeRefExpanded}
                              containerRef={tableRefExpanded}
                              value={[
                                filterColumns.ReceiptDateFrom ? (filterColumns.ReceiptDateFrom) : null,
                                filterColumns.ReceiptDateTo ? (filterColumns.ReceiptDateTo) : null,
                              ]}
                              onChange={({from, to}) => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  ReceiptDateFrom: from,
                                  ReceiptDateTo: to,
                                }));
                              }}
                              className="hide-input-outline hide-input-border"
                            />
                            {/* <IconButton type="button" sx={{ p: '0px' }}>
                              {filterColumns.ReceiptDateFrom !== '' || filterColumns.ReceiptDateTo != '' ? (
                                <Clear
                                  fontSize="small"
                                  onClick={() => {
                                    setFilterColumns((prev) => ({
                                      ...prev,
                                      ReceiptDateFrom: '',
                                      ReceiptDateTo: '',
                                    }));
                                  }}
                                />
                              ) : (
                                <SearchIcon fontSize="small" />
                              )}
                            </IconButton> */}
                          </Paper>
                        </TableCell>
                        <TableCell>
                          <Paper
                            sx={{
                              p: '2px 4px',
                              display: 'flex',
                              alignItems: 'center',
                              width: '100%',
                            }}
                          >
                            <InputBase
                              name="accountName"
                              value={filterColumns.PaidFrom}
                              onChange={(e) => filterBySearch(e, 'PaidFrom')}
                              sx={{ flex: 1 }}
                              placeholder="Search"
                              autoComplete="off"
                            />
                            <IconButton type="button" sx={{ p: '0px' }}>
                              {filterColumns.PaidFrom !== '' ? (
                                <Clear
                                  fontSize="small"
                                  onClick={() => {
                                    setFilterColumns((prev) => ({
                                      ...prev,
                                      PaidFrom: '',
                                    }));
                                  }}
                                />
                              ) : (
                                <SearchIcon fontSize="small" />
                              )}
                            </IconButton>
                          </Paper>
                        </TableCell>
                        <TableCell>
                          <Paper
                            sx={{
                              p: '2px 4px',
                              width: '100%',
                            }}
                          >
                            <Stack direction={'row'} height={'32px'} gap="5px">
                              <MoneyTextFieldRange
                                value={[filterColumns.DebitFrom,filterColumns.DebitTo]}
                                onChange={(e) => {
                                  filterBySearch(e, 'Debit', e);
                                }}
                              />

                              <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.DebitFrom !== '' || filterColumns.DebitTo !== '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        DebitFrom: '',
                                        DebitTo: '',
                                      }));
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Stack>
                          </Paper>
                        </TableCell>
                        <TableCell>
                          <Paper
                            sx={{
                              p: '2px 4px',
                              width: '100%',
                            }}
                          >
                            <Stack direction={'row'} height={'32px'} gap="5px">
                              <MoneyTextFieldRange
                                value={[filterColumns.CreditFrom,filterColumns.CreditTo]}
                                onChange={(e) => {
                                  filterBySearch(e, 'Credit', e);
                                }}
                              />

                              <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.CreditFrom !== '' || filterColumns.CreditTo !== '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        CreditFrom: '',
                                        CreditTo: '',
                                      }));
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Stack>
                          </Paper>
                        </TableCell>

                        <TableCell>
                          <Paper
                            sx={{
                              p: '2px 4px',
                              display: 'flex',
                              alignItems: 'center',
                              width: '100%',
                            }}
                          >
                            <InputBase
                              name="Comments"
                              value={filterColumns.Comments}
                              onChange={(e) => filterBySearch(e, 'Comments')}
                              sx={{ flex: 1 }}
                              placeholder="Search"
                              autoComplete="off"
                            />
                            <IconButton type="button" sx={{ p: '0px' }}>
                              {filterColumns.Comments !== '' ? (
                                <Clear
                                  fontSize="small"
                                  onClick={() => {
                                    setFilterColumns((prev) => ({
                                      ...prev,
                                      Comments: '',
                                    }));
                                  }}
                                />
                              ) : (
                                <SearchIcon fontSize="small" />
                              )}
                            </IconButton>
                          </Paper>
                        </TableCell>

                        <TableCell></TableCell>
                      </TableRow>
                      {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                          rows.slice().sort(getComparator(order, orderBy)) */}
                      {rows.length > 0 ? (
        //                 rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
        //                   const isItemSelected = isSelected(row.transactionid);
        //                   const labelId = `enhanced-table-checkbox-${index}`;
        //                   let paidFromAmounts = row.paidfromamount?.split(',');
        //                   let transaction = [];
        //                   let PaidFromAccounts = row.paidfrom?.split(',');
        //                   const paidFromComments = row.paidfromcomments?.split(',');

        //                   paidFromAmounts?.forEach((elem, index) => {
        //                     transaction = [
        //                       ...transaction,
        //                       {
        //                         AccountName: PaidFromAccounts?.[index] ?? '',
        //                         TransactionType: 'Debit',
        //                         Description: row.comments,
        //                         DebitAmount: elem,
        //                         CreditAmount: 0,
        //                         Comments:
        // (paidFromComments?.[index] && paidFromComments[index].trim() !== '') 
        //   ? paidFromComments[index]
        //   : (row.comments && row.comments.trim() !== '') 
        //     ? row.comments
        //     : '',

        //                       },
        //                     ];
        //                   });

        //                   let amounts = row.paidtoamount?.split(',');
        //                   let accounts = row.paidto?.split(',');
        //                   const paidToComments = row.paidtocomments?.split(',');
        //                   amounts?.forEach((elem, index) => {
        //                     transaction = [
        //                       ...transaction,
        //                       {
        //                         AccountName: accounts?.[index] ?? '',
        //                         TransactionType: 'Credit',
        //                         CreditAmount: elem,
        //                         DebitAmount: 0,
        //                        Comments:
        // (paidToComments?.[index] && paidToComments[index].trim() !== '') 
        //   ? paidToComments[index]
        //   : (row.comments && row.comments.trim() !== '') 
        //     ? row.comments
        //     : '',
        //                       },
        //                     ];
        //                   });
        rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
  const isItemSelected = isSelected(row.transactionid);
  const labelId = `enhanced-table-checkbox-${index}`;

  let transaction = [];

  let paidFromAmounts = row.paidfromamount?.split(',');
  let PaidFromAccounts = row.paidfrom?.split(',');
  const paidFromComments = row.paidfromcomments?.split(',');

  let amounts = row.paidtoamount?.split(',');
  let accounts = row.paidto?.split(',');
  const paidToComments = row.paidtocomments?.split(',');

  // Check if both comment arrays are empty or contain only blanks
  const noSpecificComments =
    (!paidFromComments || paidFromComments.every(c => !c?.trim())) &&
    (!paidToComments || paidToComments.every(c => !c?.trim()));

  let commentShown = false;

  // Paid From (Debit)
  paidFromAmounts?.forEach((elem, i) => {
    const hasComment = paidFromComments?.[i]?.trim();
    let comment = '';

    if (hasComment) {
      comment = paidFromComments[i];
    } else if (!commentShown && noSpecificComments && row.comments?.trim()) {
      // show row.comment only once
      comment = row.comments;
      commentShown = true;
    }

    transaction.push({
      AccountName: PaidFromAccounts?.[i] ?? '',
      TransactionType: 'Debit',
      Description: row.comments,
      DebitAmount: elem,
      CreditAmount: 0,
      Comments: comment,
    });
  });

  // Paid To (Credit)
  amounts?.forEach((elem, i) => {
    const hasComment = paidToComments?.[i]?.trim();
    let comment = '';

    if (hasComment) {
      comment = paidToComments[i];
    } else if (!commentShown && noSpecificComments && row.comments?.trim()) {
      // show row.comment only once
      comment = row.comments;
      commentShown = true;
    }

    transaction.push({
      AccountName: accounts?.[i] ?? '',
      TransactionType: 'Credit',
      CreditAmount: elem,
      DebitAmount: 0,
      Comments: comment,
    });
  });



                          const valuesArray = row.paidfromamount?.split(',');
                          const sum =
                            Array.isArray(valuesArray) &&
                            valuesArray?.reduce((total, value) => {
                              const num = parseFloat(value);
                              return isNaN(num) ? total : total + num;
                            }, 0);
                          return (
                            <React.Fragment key={index}>
                              {/* {row.RelatedTransactionDetails.map((ele, ind) => { */}
                              {transaction.map((ele, ind) => {
                                if (ind == 0) {
                                  return (
                                    <Tooltip
                                      followCursor
                                      title={row.cancelflag === 1 ? 'Cancelled' : ''}
                                      slotProps={{
                                        popper: {
                                          sx: {
                                            [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: {
                                              marginTop: '25px',
                                            },
                                          },
                                        },
                                      }}
                                    >
                                      <TableRow
                                        className={row.cancelflag === 1 ? 'rowInactiveMuted' : ''}
                                        hover
                                        // onClick={(event) => handleClick(event, row.TransactionID)}
                                        // onClick={(event) => console.log(event)}
                                        role="checkbox"
                                        aria-checked={isItemSelected}
                                        tabIndex={-1}
                                        key={ind}
                                        selected={isItemSelected}
                                        sx={{
                                          // backgroundColor: '#e7e7e796',
                                          '.MuiTableCell-root': {
                                            padding: '13px 15px',
                                            backgroundColor: 'transparent ',
                                          },
                                          backgroundColor: index % 2 == 0 ? '#a3a0a021' : '',
                                          // backgroundColor:(index>9)?colors[index-10]:(index>19)?colors[index-20]:(index>49)?colors[index-50]:colors[index]
                                        }}
                                      >
                                        {/* <TableCell
                                          padding="checkbox"
                                          sx={{
                                            ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root":
                                            {
                                              padding: "5px",
                                            },
                                          }}
                                        >
                                          <Checkbox
                                            color="primary"
                                            onClick={(event) =>
                                              handleClick(event, row.TransactionID)
                                            }
                                            checked={isItemSelected}
                                            inputProps={{
                                              "aria-labelledby": labelId,
                                            }}
                                            size="small"
                                          />
                                        </TableCell> */}
                                        <TableCell
                                          sx={{ minWidth: '100px' }}
                                          // component="th"
                                          id={labelId}
                                          scope="row"

                                          // padding="none"
                                        >
                                          <Link
                                            underline="hover"
                                            sx={{ cursor: 'pointer' }}
                                            onClick={(e) => {
                                              e.preventDefault();
                                              dispatch(updateTitle(row.vouchernumber));
                                              // dispatch(
                                              //   updateViewTitle(
                                              //     row.cancelflag == 1
                                              //       ? {
                                              //         type: "Cancelled",
                                              //         name: row.vouchernumber,
                                              //       }
                                              //       : {
                                              //         type: "",
                                              //         name: row.vouchernumber,
                                              //       }
                                              //   )
                                              // );
                                              navigate('/viewjournalentry', {
                                                state: {
                                                  id: row.transactionid,
                                                  view: true,
                                                },
                                              });
                                            }}
                                          >
                                            {row.vouchernumber}
                                          </Link>
                                        </TableCell>
                                        <TableCell sx={{ minWidth: '100px' }} align="left">
                                          {formatUnixTimestamp(row.entrydate)}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            fontWeight: 'bold',
                                            color: ele.DebitAmount === 0 ? '#20e0cf' : '#396afc',
                                            minWidth: '250px',
                                          }}
                                        >
                                          {ele.AccountName}
                                        </TableCell>
                                        {/* <TableCell
                                        sx={{
                                          minWidth: "100px",
                                          color: "#396afc",
                                          fontWeight: "bold",
                                        }}
                                        align="right"
                                      >
                                        {sum === 0
                                          ? ""
                                          : MoneyFormatv3(sum, "en-IN")}
                                      </TableCell> */}
                                        <TableCell
                                          sx={{
                                            minWidth: '100px',
                                            color: '#396afc',
                                            fontWeight: 'bold',
                                          }}
                                          align="right"
                                        >
                                          {ele.DebitAmount === 0 ? '' : MoneyFormatv3(ele.DebitAmount, 'en-IN')}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            minWidth: '100px',
                                            fontWeight: 'bold',
                                            color: '#20e0cf',
                                          }}
                                          align="right"
                                        >
                                          {ele.CreditAmount === 0 ? '' : MoneyFormatv3(ele.CreditAmount, 'en-IN')}
                                        </TableCell>
                                        <TableCell sx={{ minWidth: '100px' }}>{ele.Comments}</TableCell>

                                        <TableCell className="actionBackGround" align="center">
                                          <Box sx={{ whiteSpace: 'nowrap' }}>
                                            {row.cancelflag !== 1 && (
                                              <Tooltip title={'Edit'} placement="left" disableInteractive arrow>
                                                <IconButton
                                                  disableRipple
                                                  onClick={(event) => {
                                                    event.stopPropagation();
                                                    if (Freeze == 1) {
                                                      return handleFreeze();
                                                    }
                                                    // dispatch(updateTitle(rows.vouchernumber));
                                                    navigate('/editjournalentry', {
                                                      state: {
                                                        id: row.transactionid,
                                                      },
                                                    });
                                                  }}
                                                  aria-label="delete"
                                                  sx={{
                                                    margin: '0px 2px',
                                                    padding: '5px',
                                                    backgroundColor: '#b1d1f97d',
                                                  }}
                                                >
                                                  <Edit
                                                    sx={{
                                                      fontSize: '15px',
                                                      color: '#6096d9',
                                                    }}
                                                  />
                                                </IconButton>
                                              </Tooltip>
                                            )}
                                          </Box>
                                        </TableCell>
                                      </TableRow>
                                    </Tooltip>
                                  );
                                } else {
                                  return (
                                    <Tooltip
                                      followCursor
                                      title={row.cancelflag === 1 ? 'Cancelled' : ''}
                                      slotProps={{
                                        popper: {
                                          sx: {
                                            [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: {
                                              marginTop: '20px',
                                            },
                                          },
                                        },
                                      }}
                                    >
                                      <TableRow
                                        className={row.cancelflag === 1 ? 'rowInactiveMuted' : ''}
                                        hover
                                        // onClick={(event) => handleClick(event, row.TransactionID)}
                                        // onClick={(event) => console.log(event)}
                                        role="checkbox"
                                        aria-checked={isItemSelected}
                                        tabIndex={-1}
                                        key={ind}
                                        selected={isItemSelected}
                                        sx={{
                                          '.MuiTableCell-root': {
                                            padding: '13px 15px',
                                          },
                                          backgroundColor: index % 2 == 0 ? '#a3a0a021' : '',
                                          // backgroundColor:(index>9)?colors[index-10]:(index>19)?colors[index-20]:(index>49)?colors[index-50]:colors[index]
                                        }}
                                      >
                                        {/* <TableCell></TableCell> */}
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell
                                          sx={{
                                            fontWeight: 'bold',
                                            color: ele.DebitAmount === 0 ? '#20e0cf' : '#396afc',
                                            minWidth: '250px',
                                          }}
                                        >
                                          {ele.AccountName}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            minWidth: '100px',
                                            color: '#396afc',
                                            fontWeight: 'bold',
                                          }}
                                          align="right"
                                        >
                                          {ele.DebitAmount === 0 ? '' : MoneyFormatv3(ele.DebitAmount, 'en-IN')}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            minWidth: '100px',
                                            color: '#20e0cf',
                                            fontWeight: 'bold',
                                          }}
                                          align="right"
                                        >
                                          {ele.CreditAmount == 0 ? '' : MoneyFormatv3(ele.CreditAmount, 'en-IN')}
                                        </TableCell>
                                        <TableCell sx={{ minWidth: '100px' }}>{ele.Comments}</TableCell>

                                        <TableCell sx={{ minWidth: '100px' }} align="left"></TableCell>
                                      </TableRow>
                                    </Tooltip>
                                  );
                                }
                              })}
                            </React.Fragment>
                          );
                        })
                      ) : circularOpen == false && rows.length <= 0 && !dataCount > 0 ? (
                        <TableRow>
                          <TableCell height={400} align="center" colSpan={8}>
                            No Data Found
                          </TableCell>
                        </TableRow>
                      ) : (
                        ''
                      )}

                      {circularOpen == true &&
                        limit > 0 &&
                        Array.from({ length: limit }, (_, index) => (
                          <TableRow key={index}>
                            <TableCell colSpan={12}>
                              <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                {dataCount > 0 && (
                  <TablePagination
                    sx={{
                      scrollbarWidth: 'thin',
                      '&::-webkit-scrollbar': {
                        // width: '0.4em',
                        height: '0.4em',
                      },
                      '&::-webkit-scrollbar-track': {
                        background: `${theme.palette.primary.main}47`,
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'primary.main',
                      },
                      '&::-webkit-scrollbar-thumb:hover': {
                        background: `${theme.palette.primary.main}47`,
                      },
                    }}
                    // rowsPerPageOptions={[5, 10, 25,{ label: 'All', value: -1 }]}
                    rowsPerPageOptions={defaultRowsPerPageOptions}
                    component="div"
                    count={dataCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                )}
              </Box>
            ) : (
              <Box sx={{ width: '100%', overflow: 'hidden', boxShadow: 'none' }}>
                <TableContainer
                  ref={tableRefRegular}
                  className="custom-scrollbar"
                  sx={{
                    height: {
                      sm: 'calc( 100vh - 230px )',
                      xs: 'calc( 100vh - 180px )',
                    },
                  }}
                >
                  <Table
                    stickyHeader
                    aria-label="sticky table"
                    // sx={{ minWidth: 750 }}
                    aria-labelledby="tableTitle"
                    size={dense ? 'small' : 'medium'}
                  >
                    <EnhancedTableHead
                      EnableSearch={EnableSearch}
                      setEnableSearch={setEnableSearch}
                      numSelected={selected.length}
                      order={order}
                      orderBy={orderBy}
                      onSelectAllClick={handleSelectAllClick}
                      onRequestSort={handleRequestSort}
                      rowCount={dataCount}
                      mapArr={headCell}
                      onDelete={() => setDeleteSelectedModal(true)}
                      setShowActions = {setShowActions}
                      showActions = {showActions}
                      scroll = {scroll}
                    />
                    <TableBody ref = {jurTableRef}>
                      {EnableSearch === true && (
                        <TableRow
                          sx={{
                            '.MuiTableCell-root': {
                              padding: '8px 15px',
                            },
                            '.css-wrnu0i-MuiInputBase-root': {
                              fontSize: '13px',
                            },
                            '.css-xk0adg-MuiButtonBase-root-MuiIconButton-root': {
                              padding: '2px 4px',
                            },
                            '.css-1gqfvv-MuiPaper-root': {
                              boxShadow: 'none',
                              borderBottom: 'solid 1px rgba(0,0,0,0.24)',
                              borderRadius: '0px',
                            },
                          }}
                        >
                          {/* <TableCell></TableCell> */}
                          <TableCell>
                            <Paper
                              sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              <InputBase
                                name="VoucherNumber"
                                value={filterColumns.VoucherNumber}
                                onChange={(e) => filterBySearch(e, 'VoucherNumber')}
                                sx={{ flex: 1 }}
                                placeholder="Search"
                                autoComplete="off"
                              />
                              <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.VoucherNumber !== '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        VoucherNumber: '',
                                      }));
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Paper>
                          </TableCell>
                          <TableCell>
                            <Paper
                              sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              {/* <InputBase
                            name="date"
                            value={filterColumns.date}
                            onChange={(e) => filterBySearch(e, "EntryDate")}
                            sx={{ flex: 1 }}
                            placeholder="Search"
                            autoComplete="off"
                          /> */}
                              <DateRangeRsuite
                                ref={DateRangeRefRegular}
                                containerRef={tableRefRegular}
                                value={[
                                  filterColumns.ReceiptDateFrom ? (filterColumns.ReceiptDateFrom) : null,
                                  filterColumns.ReceiptDateTo ? (filterColumns.ReceiptDateTo) : null,
                                ]}
                                onChange={({from, to}) => {
                                  setFilterColumns((prev) => ({
                                    ...prev,
                                    ReceiptDateFrom: from,
                                    ReceiptDateTo: to,
                                  }));
                                }}
                                className="hide-input-outline hide-input-border"
                              />
                              {/* <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.ReceiptDateFrom !== '' || filterColumns.ReceiptDateTo != '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        ReceiptDateFrom: '',
                                        ReceiptDateTo: '',
                                      }));
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton> */}
                            </Paper>
                          </TableCell>
                          <TableCell>
                            <Paper
                              sx={{
                                p: '2px 4px',
                                width: '100%',
                              }}
                            >
                              <Stack direction={'row'} height={'32px'} gap="5px">
                                <MoneyTextFieldRange
                                  value={[filterColumns.AmountFrom,filterColumns.AmountTo]}
                                  onChange={(e) => {
                                    filterBySearch(e, 'Amount', e);
                                  }}
                                />

                                <IconButton type="button" sx={{ p: '0px' }}>
                                  {filterColumns.AmountFrom !== '' || filterColumns.AmountTo !== '' ? (
                                    <Clear
                                      fontSize="small"
                                      onClick={() => {
                                        setFilterColumns((prev) => ({
                                          ...prev,
                                          AmountFrom: '',
                                          AmountTo: '',
                                        }));
                                      }}
                                    />
                                  ) : (
                                    <SearchIcon fontSize="small" />
                                  )}
                                </IconButton>
                              </Stack>
                            </Paper>
                          </TableCell>
                          <TableCell>
                            <Paper
                              sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              <InputBase
                                name="Comments"
                                value={filterColumns.Comments}
                                onChange={(e) => filterBySearch(e, 'Comments')}
                                sx={{ flex: 1 }}
                                placeholder="Search"
                                autoComplete="off"
                              />
                              <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.Comments !== '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        Comments: '',
                                      }));
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Paper>
                          </TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      )}
                      {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                              rows.slice().sort(getComparator(order, orderBy)) */}
                      {rows.length > 0 ? (
                        rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                          const isItemSelected = isSelected(row.transactionid);
                          const labelId = `enhanced-table-checkbox-${index}`;
                          const valuesArray = row.paidfromamount?.split(',');
                          const title=row.cancelflag === 1 ? 'Cancelled' : '';
                          const sum =
                            Array.isArray(valuesArray) &&
                            valuesArray?.reduce((total, value) => {
                              const num = parseFloat(value);
                              return isNaN(num) ? total : total + num;
                            }, 0);
                          return (
                            <Tooltip
                              followCursor
                              slotProps={{
                                popper: {
                                  sx: {
                                    [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: {
                                      marginTop: '25px',
                                    },
                                  },
                                },
                              }}
                            >
                              <TableRow
                                hover
                                className={row.cancelflag === 1 ? 'rowInactiveMuted' : ''}
                                // onClick={(event) => handleClick(event, row.TransactionID)}
                                onClick={(event) => {
                                  navigate('/viewjournalentry', {
                                    state: {
                                      id: row.transactionid,
                                      view: true,
                                    },
                                  });
                                  // dispatch(
                                  //   updateViewTitle(
                                  //     row.CancelFlag == 1
                                  //       ? {
                                  //         type: "Cancelled",
                                  //         name: row.vouchernumber,
                                  //       }
                                  //       : {
                                  //         type: "",
                                  //         name: row.vouchernumber,
                                  //       }
                                  //   )
                                  // );
                                  dispatch(updateTitle(row.vouchernumber));
                                }}
                                role="checkbox"
                                aria-checked={isItemSelected}
                                tabIndex={-1}
                                key={index}
                                selected={isItemSelected}
                                style={{ cursor: 'pointer' }}
                                sx={{
                                  '.MuiTableCell-root': {
                                    backgroundColor: 'transparent ',
                                    borderBottom: 'none',
                                  },
                                }}
                              >
                                {/* <TableCell
                                padding="checkbox"
                                sx={{
                                  ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root":
                                  {
                                    padding: "5px",
                                  },
                                }}
                              >
                                <Checkbox
                                  color="primary"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    handleClick(event, row.TransactionID);
                                  }}
                                  checked={isItemSelected}
                                  inputProps={{
                                    "aria-labelledby": labelId,
                                  }}
                                  size="small"
                                />
                              </TableCell> */}
                                <TableCell
                                  // component="th"
                                  id={labelId}
                                  scope="row"
                                  title={title}
                                  // padding="none"
                                >
                                  {/* <Link
                                        underline="hover"
                                        sx={{ cursor: "pointer" }}
                                        onClick={(event) => {
                                          event.stopPropagation();
                                          event.preventDefault();
                                          navigate("/viewjournalentry", {
                                            state: {
                                              id: row.transactionid,
                                              view: true,
                                            },
                                          });
                                          dispatch(
                                            updateViewTitle(
                                              row.cancelflag == 1
                                                ? {
                                                    type: "Cancelled",
                                                    name: row.vouchernumber,
                                                  }
                                                : {
                                                    type: "",
                                                    name: row.vouchernumber,
                                                  }
                                            )
                                          );
                                          // dispatch(updateTitle(row.VoucherNumber));
                                        }}
                                      > */}
                                  <a
                                    className="myLink"
                                    href={`/viewjournalentry/${row.vouchernumber}?transaction=${row.transactionid}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                  >
                                    {row.vouchernumber}
                                  </a>
                                  {/* </Link> */}
                                </TableCell>
                                <TableCell align="left" title={title}>{formatUnixTimestamp(row.entrydate)}</TableCell>
                                <TableCell align="right" title={title}>{MoneyFormatv3(sum, 'en-IN')}</TableCell>
                                {/* <TableCell></TableCell>
                            <TableCell></TableCell> */}
                                <TableCell
                                  align="left"
                                  title={title}
                                  sx={{
                                    maxWidth: '200px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                  }}
                                >
                                  <Tooltip title={row.comments?.split('**')?.join('\n')} placement="left">
                                    <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                      {row.comments?.split('**')?.join('\n')}
                                    </span>
                                  </Tooltip>
                                </TableCell>
                                <TableCell className="actionBackGround" align="center" title={title} sx={{position :!showActions ? 'relative' : 'sticky'}}>
                                  <Box
                                    className="actionCellStyle"
                                  >
                                    {/* {row.cancelflag !== 1 && ( */}
                                      <Tooltip title={row.cancelflag === 1 ? "cannot Edit":'Edit'} placement="left" disableInteractive arrow>
                                        <IconButton
                                          disableRipple
                                          onClick={(event) => {
                                            event.stopPropagation();
                                            if (Freeze == 1) {
                                              return handleFreeze();
                                            }
                                            if(row.cancelflag === 1){
                                              return
                                            }
                                            dispatch(updateTitle(row.vouchernumber));
                                            navigate('/editjournalentry', {
                                              state: {
                                                id: row.transactionid,
                                              },
                                            });
                                          }}
                                          aria-label="delete"
                                          sx={{
                                            margin: '0px 2px',
                                            padding: '5px',
                                            backgroundColor: '#b1d1f97d',
                                            border:"solid 1px black"
                                          }}
                                        >

                                          {
                                            row.cancelflag === 1 ? <EditOff sx={{ fontSize: "15px", color: '#6096d9', }} /> :         <Edit
                                            sx={{
                                              fontSize: '10px',
                                              color: '#6096d9',
                                            }}
                                          />
                                          }
                                  
                                        </IconButton>
                                      </Tooltip>
                                    {/* )} */}
                                    {/* <Tooltip
                                    title={"Delete"}
                                    placement="right"
                                    disableInteractive
                                    arrow
                                  >
                                    <IconButton
                                      disableRipple
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        // setDeleteModalStatus(true);
                                        // setDeleteId(row.id)
                                        setDeleteItemModal(true);
                                        setItemData({
                                          id: row.TransactionID,
                                          ind: index,
                                        });
                                      }}
                                      aria-label="delete"
                                      sx={{
                                        margin: "0px 2px",
                                        padding: "5px",
                                        backgroundColor: "#fbc7c78c",
                                      }}
                                    >
                                      <Delete
                                        sx={{ fontSize: "15px", color: "#eb6a6a" }}
                                      />
                                    </IconButton>
                                  </Tooltip> */}
                                    {/* {row.CancelFlag !== 1 && (
                                    <Tooltip
                                      title={"Cancel"}
                                      placement="right"
                                      disableInteractive
                                      arrow
                                    >
                                      <IconButton
                                        disableRipple
                                        onClick={(event) => {
                                          event.stopPropagation();
                                          setWarningOpen({
                                            render: (
                                              <Box>
                                                <Typography>
                                                  Are you sure you want to
                                                  cancel this Payment ?
                                                </Typography>
                                                <Typography
                                                  component={"p"}
                                                  sx={{ fontSize: "smaller" }}
                                                >
                                                  This will be cancelled
                                                  immediately. You can't undo
                                                  this action.
                                                </Typography>
                                                <Box sx={{ marginTop: "8px" }}>
                                                  <TeaxtareaField
                                                    name="reason"
                                                    placeholder="Reason for Cancellation"
                                                    size="small"
                                                    fullWidth
                                                    rows={6}
                                                    state={state}
                                                    // value={state.reason}
                                                    onChange={(e) => {
                                                      console.log(
                                                        e.target.value
                                                      );
                                                      if (
                                                        e.target.value.length >
                                                        250
                                                      ) {
                                                        setState((prev) => ({
                                                          ...prev,
                                                          ["reason"]:
                                                            e.target.value,
                                                          ["errorStatus"]: {
                                                            ...prev.errorStatus,
                                                            ["reason"]: true,
                                                          },
                                                          ["errorFields"]: {
                                                            ...prev.errorFields,
                                                            ["reason"]:
                                                              "Reason for Cancellation must be less than 250 characters",
                                                          },
                                                        }));
                                                      } else if (
                                                        e.target.value.length <=
                                                        0
                                                      ) {
                                                        setState((prev) => ({
                                                          ...prev,
                                                          ["reason"]:
                                                            e.target.value,
                                                          ["errorStatus"]: {
                                                            ...prev.errorStatus,
                                                            ["reason"]: true,
                                                          },
                                                          ["errorFields"]: {
                                                            ...prev.errorFields,
                                                            ["reason"]:
                                                              "Reason for Cancellation is Required",
                                                          },
                                                        }));
                                                      } else {
                                                        console.log(
                                                          e.target.value
                                                        );
                                                        setState((prev) => ({
                                                          ...prev,
                                                          reason:
                                                            e.target.value,
                                                          ["errorStatus"]: {
                                                            ...prev.errorStatus,
                                                            ["reason"]: false,
                                                          },
                                                          ["errorFields"]: {
                                                            ...prev.errorFields,
                                                            ["reason"]: "",
                                                          },
                                                        }));
                                                      }
                                                    }}
                                                  />
                                                </Box>
                                              </Box>
                                            ),
                                            onContinue: async () => {
                                              console.log(row);
                                              await cancel(
                                                row.TransactionID,
                                                row.TransactionTypeCD,
                                                row.VoucherNumber
                                              );
                                            },
                                            onCancel: () => { },
                                          });
                                        }}
                                        aria-label="delete"
                                        sx={{
                                          margin: "0px 2px",
                                          padding: "5px",
                                          backgroundColor: "#b1d1f97d",
                                        }}
                                      >
                                        <Close
                                          sx={{ fontSize: "15px", color: "#6096d9" }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )} */}
                                    {/* <ThreeDot
                                    onEdit={
                                      row.ExpiredTimeStamp !== 0 ||
                                        row.CancelFlag == 1
                                        ? null
                                        : (event) => {
                                          event.stopPropagation();
                                          navigate("/editjournalentry", {
                                            state: { id: row.TransactionID },
                                          });
                                        }
                                    }
                                    onDelete={
                                      row.ExpiredTimeStamp !== 0
                                        ? null
                                        : (event) => {
                                          event.stopPropagation();
                                          // setDeleteModalStatus(true);
                                          // setDeleteId(row.id)
                                          setDeleteItemModal(true);
                                          setItemData({
                                            id: row.TransactionID,
                                            ind: index,
                                          });
                                        }
                                    }
                                    onView={(event) => {
                                      event.stopPropagation();
                                      dispatch(updateTitle(row.VoucherNumber));
                                      navigate("/viewjournalentry", {
                                        state: {
                                          id: row.TransactionID,
                                          view: true,
                                        },
                                      });
                                    }}
                                    onCancel={
                                      row.ExpiredTimeStamp !== 0 ||
                                        row.CancelFlag == 1
                                        ? null
                                        : (event) => {
                                          event.stopPropagation();
                                          setWarningOpen({
                                            render: (
                                              <Box>
                                                <Typography>
                                                  Are you sure you want to
                                                  cancel this Payment ?
                                                </Typography>
                                                <Typography
                                                  component={"p"}
                                                  sx={{ fontSize: "smaller" }}
                                                >
                                                  This will be cancelled
                                                  immediately. You can't undo
                                                  this action.
                                                </Typography>
                                                <Box sx={{ marginTop: "8px" }}>
                                                  <TeaxtareaField
                                                    name="reason"
                                                    placeholder="Reason for Cancellation"
                                                    size="small"
                                                    fullWidth
                                                    rows={6}
                                                    state={state}
                                                    // value={state.reason}
                                                    onChange={(e) => {
                                                      console.log(
                                                        e.target.value
                                                      );
                                                      if (
                                                        e.target.value.length >
                                                        250
                                                      ) {
                                                        setState((prev) => ({
                                                          ...prev,
                                                          ["reason"]:
                                                            e.target.value,
                                                          ["errorStatus"]: {
                                                            ...prev.errorStatus,
                                                            ["reason"]: true,
                                                          },
                                                          ["errorFields"]: {
                                                            ...prev.errorFields,
                                                            ["reason"]:
                                                              "Reason for Cancellation must be less than 250 characters",
                                                          },
                                                        }));
                                                      } else if (
                                                        e.target.value.length <=
                                                        0
                                                      ) {
                                                        setState((prev) => ({
                                                          ...prev,
                                                          ["reason"]:
                                                            e.target.value,
                                                          ["errorStatus"]: {
                                                            ...prev.errorStatus,
                                                            ["reason"]: true,
                                                          },
                                                          ["errorFields"]: {
                                                            ...prev.errorFields,
                                                            ["reason"]:
                                                              "Reason for Cancellation is Required",
                                                          },
                                                        }));
                                                      } else {
                                                        console.log(
                                                          e.target.value
                                                        );
                                                        setState((prev) => ({
                                                          ...prev,
                                                          reason:
                                                            e.target.value,
                                                          ["errorStatus"]: {
                                                            ...prev.errorStatus,
                                                            ["reason"]: false,
                                                          },
                                                          ["errorFields"]: {
                                                            ...prev.errorFields,
                                                            ["reason"]: "",
                                                          },
                                                        }));
                                                      }
                                                    }}
                                                  />
                                                </Box>
                                              </Box>
                                            ),
                                            onContinue: async () => {
                                              console.log(row);
                                              await cancel(
                                                row.TransactionID,
                                                row.TransactionTypeCD,
                                                row.VoucherNumber
                                              );
                                            },
                                            onCancel: () => { },
                                          });
                                        }
                                    }
                                  /> */}
                                  </Box>
                                </TableCell>
                              </TableRow>
                            </Tooltip>
                          );
                        })
                      ) : circularOpen == false && rows.length <= 0 && !dataCount > 0 ? (
                        <TableRow>
                          <TableCell sx={{ m: 6, height: '190px' }} align="center" colSpan={5}>
                            No Data Found
                          </TableCell>
                        </TableRow>
                      ) : (
                        ''
                      )}
                      {circularOpen == true &&
                        limit > 0 &&
                        Array.from({ length: limit }, (_, index) => (
                          <TableRow key={index}>
                            <TableCell colSpan={12}>
                              <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                {dataCount > 0 && (
                  <TablePagination
                    sx={{
                      scrollbarWidth: 'thin',
                      '&::-webkit-scrollbar': {
                        // width: '0.4em',
                        height: '0.4em',
                      },
                      '&::-webkit-scrollbar-track': {
                        background: `${theme.palette.primary.main}47`,
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'primary.main',
                      },
                      '&::-webkit-scrollbar-thumb:hover': {
                        background: `${theme.palette.primary.main}47`,
                      },
                    }}
                    // rowsPerPageOptions={[5, 10, 25,{ label: 'All', value: -1 }]}
                    rowsPerPageOptions={defaultRowsPerPageOptions}
                    component="div"
                    count={dataCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                )}
              </Box>
            )}
          </>
        )}
      </Box>
      <DeleteJournalEntry
        open={deleteItemModal}
        setOpen={setDeleteItemModal}
        itemData={itemData}
        rows={rows}
        setRows={setRows}
        getJournalEntries={getJournalEntries}
      />
      <ExportData setOpen={setExportModalOpen} open={exportModalOpen} item={exportItem} />
      <DeleteSelectedEntry open={deleteSelectedModal} setOpen={setDeleteSelectedModal} rows={rows} setRows={setRows} itemsData={selected} />
      {WarningModal}
    </Box>
  );
}

export default AllJournalEntries;
